import { useQuery } from 'react-query';
import axios from 'axios';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const fetchDomains = async (projectId) => {
  const response = await axios.get(`${API_URL}/v1/project/${projectId}/provider/domain`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response.data;
};

export const useDomains = (projectId) => {
  const { notify } = useNotification();
  return useQuery(['domains', projectId], () => fetchDomains(projectId), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
